import React from 'react';
import Avatar from '../shared/Avatar';
interface Story {
  id: string;
  username: string;
  avatar: string;
  type: 'player' | 'coach' | 'team' | 'event';
  sport: string;
  viewed: boolean;
}
const StorySection = () => {
  const stories: Story[] = [{
    id: '1',
    username: 'mbappe',
    avatar: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d',
    type: 'player',
    sport: 'football',
    viewed: false
  }, {
    id: '2',
    username: 'realmadrid',
    avatar: 'https://images.unsplash.com/photo-1522778119026-d647f0596c20',
    type: 'team',
    sport: 'football',
    viewed: false
  }, {
    id: '3',
    username: 'usainbolt',
    avatar: 'https://images.unsplash.com/photo-1570295999919-56ceb5ecca61',
    type: 'player',
    sport: 'athletics',
    viewed: true
  }, {
    id: '4',
    username: 'nbadraft',
    avatar: 'https://images.unsplash.com/photo-1574623452334-1e0ac2b3ccb4',
    type: 'event',
    sport: 'basketball',
    viewed: false
  }, {
    id: '5',
    username: 'coach_k',
    avatar: 'https://images.unsplash.com/photo-1568602471122-7832951cc4c5',
    type: 'coach',
    sport: 'basketball',
    viewed: true
  }, {
    id: '6',
    username: 'wimbledon',
    avatar: 'https://images.unsplash.com/photo-1541534741688-6078c6bfb5c5',
    type: 'event',
    sport: 'tennis',
    viewed: false
  }];
  return <div className="px-4 py-3 border-b border-gray-100" data-id="element-379">
      <div className="flex space-x-4 overflow-x-auto pb-2 scrollbar-hide" data-id="element-380">
        {stories.map(story => <div key={story.id} className="flex flex-col items-center" data-id="element-381">
            <div className={`p-0.5 rounded-full ${story.viewed ? 'bg-gray-300' : 'bg-gradient-to-tr from-green-500 via-green-400 to-indigo-500'}`} data-id="element-382">
              <Avatar src={story.avatar} size="lg" bordered={false} sport={story.sport} data-id="element-383" />
            </div>
            <span className="text-xs mt-1 truncate w-16 text-center" data-id="element-384">
              {story.username}
            </span>
          </div>)}
      </div>
    </div>;
};
export default StorySection;